// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file pin-message.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { MessageType } from './enums_pb'
import { file_enums } from './enums_pb'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file pin-message.proto.
 */
export const file_pin_message: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChFwaW4tbWVzc2FnZS5wcm90byJ0CgpQaW5NZXNzYWdlEg0KBWNsb2NrGAEgASgEEhIKCm1lc3NhZ2VfaWQYAiABKAkSDwoHY2hhdF9pZBgDIAEoCRIOCgZwaW5uZWQYBCABKAgSIgoMbWVzc2FnZV90eXBlGAUgASgOMgwuTWVzc2FnZVR5cGViBnByb3RvMw',
    [file_enums],
  )

/**
 * @generated from message PinMessage
 */
export type PinMessage = Message<'PinMessage'> & {
  /**
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string

  /**
   * @generated from field: string chat_id = 3;
   */
  chatId: string

  /**
   * @generated from field: bool pinned = 4;
   */
  pinned: boolean

  /**
   * The type of message (public/one-to-one/private-group-chat)
   *
   * @generated from field: MessageType message_type = 5;
   */
  messageType: MessageType
}

/**
 * Describes the message PinMessage.
 * Use `create(PinMessageSchema)` to create a new message.
 */
export const PinMessageSchema: GenMessage<PinMessage> =
  /*@__PURE__*/
  messageDesc(file_pin_message, 0)
